import React from 'react';
import ErrorPage from '../../../components/errorPages/ErrorPage';
import useTranslate from '../../../hooks/useTranslate';
const errorMessage = {
    english: "The information you're trying to access is not currently available - please try again. " +
        "If you continue to receive this error and you require immediate support, please contact us.",
    spanish: 'La información a la que está intentando acceder no está disponible en este momento; inténtelo de nuevo. ' +
        'Si continúa recibiendo este error y necesita ayuda inmediata, comuníquese con nosotros.',
};
const PublicErrorPage = () => {
    const { t } = useTranslate();
    return <ErrorPage message={t(errorMessage)} link="" linkTitle="" theme=""/>;
};
export default PublicErrorPage;
